export default "__VITE_ASSET__1A8luvi9__"